import Settings from '../olr-common/Settings';

export default function AttendanceService($http) {

  this.saveAttendance = function(attendanceObj) {
    let url = Settings.backendEnv + "/api/v1/attendance";
    var req = {
      method:  "POST",
      url:    url,
      data:   attendanceObj
    };

    return $http(req);
  };

  this.getAllDates = function(classRoomId, subjectId){
    let url = Settings.backendEnv + "/api/v1/attendancedates/"+ classRoomId+ "/" +subjectId;
    return $http({method: 'GET',url: url});
  };

  this.getAttendanceDetails = function(classRoomId, subjectId, date) {
    let url = Settings.backendEnv + "/api/v1/attendance/"+ classRoomId+ "/" +subjectId + "/" +date;
    var req = {
      method: "GET",
      url:    url
    };

    return $http(req);
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/AttendanceService.js
 **/